import City from "../../entities/pak/City";
import { IMunicipality } from "../../entities/pak/types";
import { IManhattanFactory } from "../manhattan/types";

export const PakCitiesFactory: IManhattanFactory = class PakCitiesFactory {

  static create(cities: IMunicipality[]) {
    return cities.map((city) => {
      let cityMunicipality = city.municipality;

      if (typeof city.city !== 'undefined' && city.city !== '' && city.city !== null) {
        cityMunicipality = `${city.city} - ${city.municipality}`;
      }

      return new City(
        city.city,
        city.municipality,
        cityMunicipality
      );
    });
  }

};
